import { uiRows } from './types-def.js';
/** `web/templates` (1.S): template chips. */
export const TEMPLATES_INTERACTIONS = uiRows([
    {
        id: 'templates.chips.apply',
        module: 'web/templates',
        behavior: "On an empty document, a template chip fills it with that template's blocks",
        owner: '1.S',
        since: 'exit-1a',
    },
]);
//# sourceMappingURL=templates.js.map